const breakPoint = 767;
let resizeFlag   = false;
let windowWidth  = window.innerWidth;
let windowHeight = window.innerHeight;
let windowWidthJ = $(window).width();



const videoControl = (action, target) => {
  var $playerWindow = $(target)[0].contentWindow;
  $playerWindow.postMessage('{"event":"command","func":"' + action + '","args":""}', '*');
}

// ------------------------------------------------------------------------
// preload
// ----- BOTH
// ------------------------------------------------------------------------
const preload = () => {
  $(window).on("load", function () {
    $("body").removeClass("preload");
    $("body").css("opacity", "");
  });
};

// ------------------------------------------------------------------------
// anchorLink
// ----- BOTH
// ------------------------------------------------------------------------
const anchorLink = () => {
  $("a[href^='#']").on("click", function(){
    var linkSpeed    = 800;
    var linkHref     = $(this).attr("href");
    var linkTarget   = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
    var linkAdjust   = 0;
    var linkPosition = linkTarget.offset().top;
    $("html, body").animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, "swing");
    return false;
  });
};


// ------------------------------------------------------------------------
// scrollAnime
// ------------------------------------------------------------------------
const scrollAnime = () => {
  let margin = 0;
  if (matchMedia('(max-width: 768px)').matches) {
    margin = 200;
  } else {
    margin = 500;
  }
  $(".js-sc").each(function (i, node) {
    gsap.to(node, {
      scrollTrigger: {
        trigger: node,
        start: 'top bottom-=' + margin,
        toggleClass: { targets: node, className: "animated" },
        once: true,
      }
    });
  });
};


// ------------------------------------------------------------------------
// loadAnime
// ------------------------------------------------------------------------
const loadAnime = () => {
  $(window).on("load", function () {
    $(".js-ld").toggleClass("animated");
  });
};


// ------------------------------------------------------------------------
// countDown
// ------------------------------------------------------------------------
const cd = (date,nowDate,durDate) => {
  const countDownDate = date;

  let now = nowDate;
  
  let duration = durDate;

  let days = Math.floor(duration / (1000 * 60 * 60 * 24));
  let hours = Math.floor((duration % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  let minutes = Math.floor((duration % (1000 * 60 * 60)) / (1000 * 60));
  let seconds = Math.floor((duration % (1000 * 60)) / 1000);
  days =  String(days).padStart(2,'0');
  hours =  String(hours).padStart(2,'0');
  minutes =  String(minutes).padStart(2,'0');
  seconds =  String(seconds).padStart(2,'0');

  document.getElementById("main-cd_text").innerHTML =  "<span>" + days + "</span><span class='main-cd_c'>:</span><span>" + hours + "</span><span class='main-cd_c'>:</span><span>"
  + minutes + "</span><span class='main-cd_c'>:</span><span>" + seconds + "</span>";

  if (duration < 0) {
    document.getElementById("main-cd_text").innerHTML = "<span>00</span><span class='main-cd_c'>:</span><span>00</span><span class='main-cd_c'>:</span><span>00</span><span class='main-cd_c'>:</span><span>00</span>";
  }
}
const countDown = () => {
  const countDownDate = new Date("May 26, 2022 11:00:00").getTime();

  const nowFirst = new Date().getTime();
  const durFirst = countDownDate - nowFirst;

  cd(countDownDate,nowFirst,durFirst);

  let i = setInterval(function() {
    let nowCount = new Date().getTime();
    let durCount = countDownDate - nowCount;
    
    cd(countDownDate,nowCount,durCount);
    if (durCount < 0) {
      clearInterval(i);
    }
  }, 1000);
};


export {
  preload,
  anchorLink,
  scrollAnime,
  loadAnime,
  countDown
}



// WEBPACK FOOTER //
// ./src/assets/js/include/module.js